import { hot } from "react-hot-loader/root";
import React from "react";
import { Provider } from "react-redux";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import LuxonUtils from "@date-io/luxon";
import Application from "application/components/Application";
import { theme } from "theme.js";
import { creatorQueryClient } from "../application/queryClients";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClientProvider } from "react-query";

const Root = ({ store, history }) => (
  <Provider store={store}>
    <MuiPickersUtilsProvider utils={LuxonUtils}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={creatorQueryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <Application history={history} />
        </QueryClientProvider>
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  </Provider>
);

export default hot(Root);
